module.exports = __webpack_public_path__ + "static/media/money-1.50e2079f.png";